import React, { useState } from "react";
import "./Navbar.css"; // Include styles for menu and buttons
import Signup from "../Modal/Signup";
import Signin from "../Modal/Signin";

const Navbar = () => {
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isSignINOpen, setIsSignInOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to toggle menu

  const toggleSignUpModal = () => {
    setIsSignUpOpen(!isSignUpOpen);
  };

  const toggleSignInModal = () => {
    setIsSignInOpen(!isSignINOpen);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar flex items-center justify-between px-4 py-2 relative">
      <a href="https://www.earthtechindia.com/" target="_blank" rel="noopener noreferrer"> <img src="/logo.png" alt="Logo" className="h-8" />
      </a>

      {/* <div className="buttons-group hidden md:flex">
        <button className="btn" onClick={toggleSignInModal}>
          Sign In
        </button>
        <button className="btn" onClick={toggleSignUpModal}>
          Sign Up
        </button>
      </div> */}
      <div className="buttons-group hidden md:flex mr-1">
        <p className="text-md font-bold rounded-full px-3	 py-1 cursor-pointer	 text-white border border-sm border-white bg-red-600"  onClick={toggleMenu}
        aria-label="Toggle menu">E</p>
        {isMenuOpen && (
        <div class="z-[1000] absolute top-20 right-5 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-sm shadow dark:bg-gray-700 dark:divide-gray-600" id="user-dropdown">
          <div class="px-4 py-3 text-start">
            <span class="block text-sm   text-red-600">EarthTech</span>
            <span class="block text-sm  text-gray-500 truncate dark:text-gray-400">info@earthtechai.com</span>
          </div>

          <ul class="py-2 text-start" aria-labelledby="user-menu-button">
           
            <li>
              <a class="block px-4 mt-1 py-2 text-sm text-gray-700  dark:text-gray-200 ">Sign out</a>
            </li>
          </ul>

        </div>
      )}
      </div>

      <button
        className="menu-button block md:hidden"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        {isMenuOpen ? (
          // Close Icon
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-red-600"
          >
            <path
              d="M6 6L18 18M6 18L18 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          // Hamburger Menu Icon
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-red-600"
          >
            <path
              d="M4 6H20M4 12H20M4 18H20"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>

      {isMenuOpen && (
        <div class="z-[1000] absolute top-20 right-5 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-sm shadow dark:bg-gray-700 dark:divide-gray-600" id="user-dropdown">
          <div class="px-4 py-3 text-start">
            <span class="block text-sm text-red-600">EarthTech</span>
            <span class="block text-sm  text-gray-500 truncate dark:text-gray-400">info@earthtechai.com</span>
          </div>

          <ul class="py-2 text-start" aria-labelledby="user-menu-button">
           
            <li>
              <a class="block px-4 mt-1 py-2 text-sm text-gray-700  dark:text-gray-200 ">Sign out</a>
            </li>
          </ul>

        </div>
      )}


      {/* Modals */}
      {isSignUpOpen && <Signup onClose={toggleSignUpModal} />}
      {isSignINOpen && <Signin onClose={toggleSignInModal} />}
    </nav>
  );
};

export default Navbar;
